function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgApplications = function SvgApplications(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "pending for approval_menu",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2175",
    style: {
      fill: "none"
    },
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4341"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 949",
    d: "m87.011 316-.768-.768-1.532 1.568-.891-.8-.747.833 1.662 1.264z",
    style: {
      fill: "#838383"
    },
    transform: "translate(-78.579 -311.329)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 950",
    d: "m84.734 321.833 2.276-2.1-.768-.768-1.532 1.569-.891-.8-.747.833z",
    style: {
      fill: "#838383"
    },
    transform: "translate(-78.579 -311.329)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2417",
    transform: "translate(9.197 5.209)",
    style: {
      fill: "#838383"
    },
    d: "M0 0h3.6v1.064H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2418",
    transform: "translate(9.197 8.836)",
    style: {
      fill: "#838383"
    },
    d: "M0 0h3.6v1.064H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 951",
    d: "M92.862 311.329H81.691a1.292 1.292 0 0 0-1.288 1.288V322.7h1.5v-8.819a1.036 1.036 0 0 1 1.047-1.017h8.664a1.035 1.035 0 0 1 1.046 1.017v10.344c0 1.267-.622 1.728-1.477 1.728-1.469 0-1.685-2.258-1.685-2.258H78.579c0 3.372 2.455 3.638 2.455 3.638h10.388c1.539 0 2.728-.546 2.728-3.287v-11.429a1.292 1.292 0 0 0-1.288-1.288z",
    style: {
      fill: "#838383"
    },
    transform: "translate(-78.579 -311.329)"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgApplications, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/applications.620cd246.svg";
export { ForwardRef as ReactComponent };